/**
 * Caterer Service
 * Register Angular Services for Vendor with type=caterer
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Caterer', ['$resource', function($resource){
    return $resource('/api/v2/caterer/:id');
}]);
